import { sortBy } from 'lodash';
import { FinancialStatementPeriod } from 'common/types/financials';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import parseDatabaseValue from 'utilities/parseDatabaseValue';

const reverseParser = ({
  cells,
  columns,
  allowEmptyValues,
  rowConfig,
  fieldAttributes,
}: {
  cells: Record<string, any>;
  columns: FinancialStatementPeriod[];
  allowEmptyValues: boolean;
  rowConfig: Record<string, any>[];
  fieldAttributes: Record<string, any>;
}) => {
  let tableColumns: FinancialStatementPeriod[] = [];

  const sortedColumns = sortBy([...columns], ['order']);
  const alphabet = alphabetGenerator([], sortedColumns.length);

  sortedColumns.forEach((column, columnIndex) => {
    const columnLegend = alphabet[columnIndex];
    const specificData = column.income_statement;

    // replace updated values
    rowConfig.forEach((cell, cellIndex) => {
      const key = columnLegend + (cellIndex + 1);
      const defaultValue = cell.defaultValue || null;
      const type = cell.dbType || null;
      const format = cell.format || null;
      const value = cells[key] ? cells[key].value : defaultValue;
      const { gridType } = cell;
      const decimalPlaces = fieldAttributes[cell.alias]?.decimal_places;

      if (cell.alias && cells[key]) {
        specificData[cell.alias] = parseDatabaseValue({
          type,
          value,
          format,
          allowEmptyValues,
          gridType,
          decimalPlaces,
        });
      }
    });

    tableColumns = [...tableColumns, column];
  });

  return tableColumns;
};

export default reverseParser;
